/**
 * @file Defines the {@link PORTRAIT_GAME_HISTORY_TABLE} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Config for headings to be display in portrait game history table
  * @type {object}
  * @default
  * @constant
  * @property {object} headings                    - Object for each row of headings to display in game history
  * @property {portrait-game-history-config} one   - Headings to display in first row of game history
  * @property {portrait-game-history-config} two   - Headings to display in second row of game history
  * @property {portrait-game-history-config} three - Headings to display in third row of game history
  */
 const PORTRAIT_GAME_HISTORY_TABLE = {

    headings: {

        one: [

            { text: 'Status' },
            { text: 'Channel', colspan: 2 },
            { text: 'Total Win' }

        ],

        two: [

            { text: 'Bet' },
            { text: 'Bet/Lines', colspan: 2 },
            { text: 'Coins' }

        ],

        three: [

            { text: 'Placed', colspan: 2 },
            { text: 'Settled', colspan: 2 }

        ]

    }

 }

 export { PORTRAIT_GAME_HISTORY_TABLE }